export const STANDALONE_SESSION_MAX_AGE_MS = 60 * 60 * 1000;
export const IFRAME_SESSION_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
export const IFRAME_SESSION_EXPIRED_EVENT = "iframe-session-expired";

export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

export const clearSession = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("loginTimestamp");
};

export const getSessionState = ({
  iframe = isInIframe(),
  now = Date.now(),
} = {}) => {
  const storedTimestamp = localStorage.getItem("loginTimestamp");

  if (storedTimestamp === null) {
    return "missing";
  }

  const loginTimestamp = Number(storedTimestamp);
  const maxAge = iframe
    ? IFRAME_SESSION_MAX_AGE_MS
    : STANDALONE_SESSION_MAX_AGE_MS;

  if (!Number.isFinite(loginTimestamp) || now - loginTimestamp > maxAge) {
    return "expired";
  }

  return "active";
};

export const expireIframeSession = () => {
  clearSession();
  window.dispatchEvent(new Event(IFRAME_SESSION_EXPIRED_EVENT));
};
